import React from 'react';
import { AppBar, useSidebarState } from 'react-admin';
import { Box, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ProfileMenu from '../profile-menu/ProfileMenu';
import LanguageSwitcher from '../language-switcher/LanguageSwitcher';
import logoUrl from '../../assets/m_logo.svg';

/**
 * Modern app bar.
 * - Translucent white with backdrop blur (defined in theme).
 * - Desktop: burger toggle po lewej, dalej logo + pigulka "Admin"; po prawej jezyk i profil.
 * - Mobile: burger przenosi sie na prawy skraj, do pozostalych ikon — kciuk trzyma
 *   telefon przy prawej krawedzi, a lewy gorny rog jest tam najtrudniej dostepny.
 */
const Appbar = (props: any) => {
  const [open, setOpen] = useSidebarState();

  /* Ten sam przycisk renderowany w dwoch miejscach, na przemian ukrywany breakpointem.
     `display: none` wycina element z drzewa dostepnosci, wiec czytnik ekranu widzi
     tylko jeden. Zmiana kolejnosci samym `order` nie wystarczyla: ProfileMenu wstawia
     react-admin po naszych dzieciach, wiec zeby burger wyladowal ZA nim, musi byc
     bezposrednim dzieckiem AppBara z `order` wyzszym od domyslnego 0. */
  const menuToggle = (sx: object) => (
    <IconButton
      aria-label="toggle side menu"
      aria-expanded={open}
      onClick={() => setOpen(!open)}
      sx={{
        color: 'var(--color-text-secondary)',
        borderRadius: 'var(--radius-md)',
        flexShrink: 0,
        '&:hover': { backgroundColor: 'var(--color-bg-subtle)' },
        ...sx,
      }}
    >
      <MenuIcon />
    </IconButton>
  );

  return (
    <AppBar
      {...props}
      userMenu={<ProfileMenu />}
      elevation={0}
      sx={{
        '& .RaAppBar-title': { display: 'none' },
        '& .RaAppBar-menuButton': { display: 'none !important' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 1.5, md: 2.5 },
          flex: 1,
          minWidth: 0,
        }}
      >
        {menuToggle({ display: { xs: 'none', sm: 'inline-flex' } })}
        <Box sx={{ display: 'flex', p: 1, flexShrink: 0 }}>
          <Box
            component="img"
            src={logoUrl}
            alt="Menusso"
            sx={{
              height: 28,
              width: 'auto',
              flexShrink: 0,
            }}
          />
        </Box>
        <Typography
          sx={{
            display: { xs: 'none', sm: 'inline' },
            ml: 0.5,
            px: 1.25,
            py: 0.25,
            borderRadius: 'var(--radius-pill)',
            backgroundColor: 'var(--color-primary-soft)',
            color: 'var(--color-primary-active)',
            fontSize: 'var(--text-2xs)',
            fontWeight: 700,
            letterSpacing: 'var(--tracking-wide)',
            textTransform: 'uppercase',
          }}
        >
          Admin
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }} />
      <LanguageSwitcher />
      {menuToggle({ display: { xs: 'inline-flex', sm: 'none' }, order: 1 })}
    </AppBar>
  );
};

export default Appbar;
